package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class CourseState(
    val id: String,
    cours: String = "",
    mois: String = "",
    annee: String = "",
    isOngoing: Boolean = false,
    description: String = ""
) {
    var cours by mutableStateOf(cours)
    var mois by mutableStateOf(mois)
    var annee by mutableStateOf(annee)
    var isOngoing by mutableStateOf(isOngoing)
    var description by mutableStateOf(description)
}